// Default spacing for inline list
export const LIST_INLINE_HORIZONTAL_OFFSET = {
  xs: 16,
  md: 20,
  xl: 24
};
// Default spacing for expanded inline list
export const LIST_INLINE_VERTICAL_OFFSET = {
  xs: 12,
  md: 16,
  xl: 20
};
export const LIST_ITEM_PADDING_VERTICAL = {
  xs: 16,
  sm: 20,
  lg: 24
};
export const LIST_ITEM_PADDING_HORIZONTAL = {
  xs: 16,
  sm: 20,
  lg: 24
};
export const LIST_CARD_VERTICAL_SPACING = {
  xs: 16,
  md: 20,
  xl: 24
};
export const LIST_BLOCK_VERTICAL_SPACING = {
  xs: 12,
  sm: 16,
  lg: 20,
  xl: 24
};
export const LIST_IMAGE_LINK_VERTICAL_SPACING = {
  xs: 12,
  sm: 16,
  lg: 24,
  xl: 32
};